/**
 * @author Arul Vivek
 */
 import service from '../Common'
 import constants from '../../../settings/shared/constants'
 
 function PostTenant(tenantData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.postTenant,
            method: 'POST',
            headers: headers,
            data:  tenantData
        }); 
 }

 function getAllTenant() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.getAllTenant,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function getParticularTenant(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.getSingleTenant+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function activateParticularTenant(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.activeTenant+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function deactivateParticularTenant(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.deactiveTenant+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function removeParticularTenant(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.removeSingleTenant+id,
            method: 'DELETE',
            headers: headers,
            data:  ""
        }); 
 }

 function UpdateTenantData(id,tenantData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.updateTenant+id,
            method: 'PUT',
            headers: headers,
            data:  tenantData
        }); 
 }

 function getTenantType() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.superAdmin.getTenantType,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
  
 //To export authentication function
 const SuperAdminService = {
    PostTenant,getAllTenant,getParticularTenant,removeParticularTenant,UpdateTenantData,activateParticularTenant,
    deactivateParticularTenant,getTenantType
 }
 
 export default SuperAdminService;
 